import React from 'react';

/**
 * use to insert a blank space between other UI elements
 *
 * *note: either one of the 'stretchTo' or 'size' props should be provided*
 * @export
 * @param {{
 * [grow=1]: Number,
 * [stretchTo={[x="0%"]: String, [y="0%"]: String}]: {x: String, y: String },
 * size: {x: String, y: String}
 * }} props these special props may be used:
 * - grow: used with the "flex-grow" CSS property to determine how much the Spacer should expand to fill its parent container
 * - stretchTo: used to define the maximum size, in %, of the parent container that the Spacer can grow to fill *optional*
 * - size: used to define the minimum size, in pixels, of the Spacer element *optional*
 * @returns an empty space with a fixed or dynamic size
 */
export default function Spacer(props: { grow?: number; stretchTo?: { x?: string; y?: string; }; size?: { x?: string; y?: string; }; className?: any; style?: React.CSSProperties; })
{
	const style = {
		flexGrow: props.grow ? props.grow : 1,
		minWidth: "unset",
		maxWidth: (props.stretchTo && props.stretchTo.x) ? props.stretchTo.x : "0%",
		minHeight: "unset",
		maxHeight: (props.stretchTo && props.stretchTo.y) ? props.stretchTo.y : "0%",
	}

	if (props.size && props.size.x)
	{
		style.minWidth = props.size.x;
	}

	if (props.size && props.size.y)
	{
		style.minHeight = props.size.y;
	}

	return (
		<div 
			style={{
				flexGrow: props.grow ? props.grow : 1,
				maxWidth: props.stretchTo?.x ? props.stretchTo.x : "0%",
				maxHeight: props.stretchTo?.y ? props.stretchTo.y : "0%",
				minWidth: props.size?.x ? props.size?.x : "unset",
				minHeight: props.size?.y ? props.size?.y : "unset",
				...props.style,
			}}
			className={[
				"spacer",
				(props.className ? props.className : ""),
			].join(' ')}
		/>
	);
}